/* eslint-disable ember/no-computed-properties-in-native-classes */
// Extends From
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed, get, set } from '@ember/object';
import { mapBy } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
// Internal Imports
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class IndexController extends Controller {
  @action
  setStatus(value) {
    this.status = value;
  }

  @tracked
  filters = [];

  @tracked status = false;

  // scheduleMedications provides an intermediary CP so the @each dependent key
  // below stays one level deep.
  @mapBy('model.schedules', 'medication')
  scheduleMedications;

  @computed(
    'model.schedules.@each.deleted',
    'scheduleMedications.@each.deleted',
  )
  get currentSchedules() {
    return this.model.schedules.filter(
      (item) => !item.deleted && !item.get('medication.deleted'),
    );
  }

  @computed('currentSchedules.@each.scheduledToday')
  get todaysSchedules() {
    return this.currentSchedules.filter((schedule) => {
      return schedule.scheduledToday;
    });
  }

  @computed(
    'todaysSchedules.{[],@each.administeredToday}',
    'filters.@each.{field,value}',
    'status',
  )
  get filteredSchedules() {
    // Filter by status
    let todaysSchedules = this.todaysSchedules.filter((row) => {
      return row.administeredToday === this.status;
    });

    // Determine datatypes for any specified filters.
    let filters = this.filters.map((filter) => {
      return {
        key: filter.field,
        dataType: DataType.STRING,
        value: filter.value,
      };
    });

    // Apply all filters to each row in one hit, to avoid iterating over a
    // (potentially) large dataset multiple times.
    return todaysSchedules.filter((row) => {
      return filters.every((filter) => {
        // Generic filter processing.
        return filterValue(
          get(row, filter.key) ?? '',
          filter.dataType,
          filter.value,
        );
      });
    });
  }

  @action
  filter(field, value) {
    let filter = findBy(this.filters, 'field', field);
    if (isEmpty(filter)) {
      // No existing filter on this field; add it.
      this.filters = [...this.filters, { field, value }];
      return;
    }

    if (isEmpty(value)) {
      // Filter has been cleared; remove it.
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      // Existing filter has been changed; update it.
      set(filter, 'value', value);
    }
  }
}
